import React, { FC } from 'react';
import SAlert from './Alert.styles';
import { TAlertProps } from './Alert.types';

const Alert: FC<TAlertProps> = ({ message, ...props }) => {
  return <SAlert message={message} {...props} />;
};

export default Alert;
